// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__4Slkw","col":"CardReaderDesc_col__VNRkw","label":"CardReaderDesc_label__29TLp"};